import { CSSProperties, JSXElementConstructor, ReactElement, useEffect, useState } from 'react';
import { ModalProps as MuiModalProps, Zoom } from '@mui/material';
import { clsx } from 'clsx';
import { HoverTracker } from '../../shared/components/HoverTracker/HoverTracker';
import { StyledModal } from '../StyledModal/StyledModal';

export interface BaseModalProps extends MuiModalProps {
  children: ReactElement;
  open: boolean;
  transitionTime?: number;
  placement?: 'center' | 'top';
  variant?: 'primary' | 'custom';
  className?: string;
  contentClassName?: string;
  styling?: CSSProperties;
  TransitionComponent?: JSXElementConstructor<object>;
  onClose?: (event: object, reason: string) => void;
  transitionEndListener?: VoidFunction;
  dialogHoverTrackingAction?: string;
  dataId?: string;
}

export default function BaseModal(props: BaseModalProps) {
  const {
    children,
    TransitionComponent = Zoom,
    transitionTime = 300,
    open,
    placement = 'center',
    className = '',
    transitionEndListener,
    dialogHoverTrackingAction,
    variant = 'primary',
    contentClassName = '',
    styling,
    ...rest
  } = props;
  const [openModal, setOpenModal] = useState(open);
  const alignmentClass = `${placement}-align`;

  // TODO: update this once we have global state available and add test case as well
  const isLoggedIn = true;

  useEffect(() => {
    setOpenModal(open);
  }, [open]);

  useEffect(() => {
    if (!isLoggedIn && openModal) {
      setOpenModal(false);
    }
  }, [isLoggedIn]);

  return (
    <StyledModal open={openModal} className={clsx(alignmentClass, className)} {...rest}>
      <TransitionComponent
        appear
        in={openModal}
        timeout={transitionTime}
        role='presentation'
        addEndListener={transitionEndListener}
      >
        <HoverTracker trackingAction={dialogHoverTrackingAction}>
          <div className={`${variant} ${contentClassName}`} style={{ ...styling }}>
            {children}
          </div>
        </HoverTracker>
      </TransitionComponent>
    </StyledModal>
  );
}
